import React from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../containers/Modal/ModalContainer";

const ModalAlertToCloneInterview = ({ showModal, setShowModal, submitButtonAction }) => {
  const { t } = useTranslation();
  return (
    <ModalContainer
      modalTitle={t("Interview")}
      isOpen={showModal}
      submitButtonAction={() => submitButtonAction()}
      submitButtonTitle={t("Confirm")}
      submitButtonType="button"
      cancelButtonAction={() => setShowModal(false)}
      cancelButtonTitle={t("Cancel")}
      closeModal={() => setShowModal(false)}
      crossmarkAction={() => setShowModal(false)}
    >
      {t("Are you sure you want to create a new interview ?")}
    </ModalContainer>
  );
};

export default ModalAlertToCloneInterview;
